/* template */
<template><div class="mpx-root-view"><div class="navbarBg"><es-navbar :left-arrow="(true)" title="密码找回"></es-navbar></div><mpx-view @tap="goBack" class="goPageBack"></mpx-view><div class="backgroundStyleBox"><div class="backgroundStyle"><div class="es-background-card"><div class="inputContainerStyle"><div class="messageStyle">证件类型</div><div class="es-input-style"><div class="inputStyle">{{ certificateType }}</div></div><mpx-view @tap="handleNext" class="es-next-box"><es-icon name="angle-right" size="20"/></mpx-view></div><div class="inputContainerStyle"><div class="messageStyle">证件号码</div><div class="es-input-id-number"><mpx-input :style='["width: 100%"] | transRpxStyle' :type="(cardType)" placeholder="请输入证件号码" :value="idNumber" mpxModelEvent="input" @mpxModel='__model("idNumber", $event, ["value"], undefined)' :maxlength="(maxLeng)" @blur="inputCheckBlur" class="inputStyle"/><div :class="(idNumberComputed)" class="es-retrieval-error">请填写正确的证件号码</div></div></div><div class="inputContainerStyle"><div class="messageStyle">姓名</div><div class="es-input-style es-input-style-bottom"><mpx-input type="text" placeholder="请输入真实姓名" :value="idName" mpxModelEvent="input" @mpxModel='__model("idName", $event, ["value"], undefined)' class="inputStyle"/></div></div><drawer-bottom :show="(show)" @close="closeDialog" title="请选择证件类型" :showDefaultNav="(true)"><div class="es-travel-container"><mpx-view v-for="(item, index) in (list)" @tap="changeItem" :data-code="(item.code)" :data-name="(item.name)" :key="item['{{item.code}}']" class="es-travel-list"><span>{{ item.name }}</span><es-icon name="check" size="20" class="es-mark" v-if="(currentIndex == item.code)"></es-icon></mpx-view></div></drawer-bottom></div></div><div class="es-next-step"><mpx-view @tap="onClickNext" class="buttonStyle">下一步</mpx-view></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m1505591b"}'>
  @import '~@/mixins/stylus/color.styl'
  .navbarBg
    background-color $train-color-fff

  .goPageBack
    position absolute
    left 0px
    top 2px
    z-index 999
    width 100%
    height 60px
    // background #000000
  .es-content-hover
    color $train-color-background
  .es-background-card
    background #ffffff
    border-radius 8px
    padding 5px 0px 0px 5px
  .tab-label
    padding 0 5px
    position absolute
    font-size 10px
    height 18px
    line-height 18px
    color #ffffff
    background #FD6C19
    border-radius 9px
    border 1px solid #FFFFFF
  .backgroundStyleBox
    display flex
    flex-direction column
    justify-content space-between
    box-sizing border-box
    background-color $train-color-background
    height 90%
  .backgroundStyle
    padding 12px
    background-color $train-color-background
  .title
    margin-left 10px
    padding 10 20
    color black
    font-size 20px
    text-align center
    background #FD6C19
    border 1px solid #ffffff
    width 250px
    height 25px
  .titleStyle
    padding-top 0
    padding-bottom 12px
    color #000000
    font-size 16px
  .titleStyles
    padding-top 24px
    padding-bottom 12px
    color #000000
    font-size 16px
  .contentStyle
    color $train-color-666
    font-size 14px
  .messageStyle
    color $train-color-333
    font-size 15px
    display inline-block
    width 70px
  .messageBorder
    color #C0C0C0
    padding 0 10px
  .buttonStyle
    margin-top 16px
    color #ffffff
    background $train-color-theme-blue
    font-size 16px
    border-color $train-color-theme-blue
    padding 10px 10px
    text-align center
    border-radius 8px
  .search
    color $train-color-divider-ccc
    font-size 15px
    height 44px
    padding 13px
    width 100%
    outline none
    box-sizing border-box
  .inputContainerStyle
    padding 10px
    display flex
    align-items center
    width 100%
    box-sizing border-box
    position relative
    height 55px
  .inputStyle
    font-size 15px
    color $train-color-666
    height 21px
    outline none
  .inputStyle::placeholder
    color $train-color-999
  .button-not-active
    background $train-color-divider-ccc
  .es-next-step
    height 90px
    background #ffffff
    padding 0px 16px
  .es-next-box
    width 100%
    height 25px
    position absolute
    right 5px
    top 15px
    color $train-color-666
    display flex
    justify-content flex-end
    align-items center
  .es-input-id-number
    position relative
    width 255px
    height 21px
  .es-input-id-number:after
    content ' '
    display block
    width 100%
    height 1px
    background RGB(240, 241, 244)
    position absolute
    left 0
    top 38px
    z-index 1
  .es-retrieval-error
    color #f53f3f
    position absolute
    left 0px
    top 20px
    font-size 13px
    width 100%
    border-bottom 1px red solid
    z-index 2
  .not-hover
    display none
  .es-travel-container
    padding 0px 12px 12px 12px
    background #ffffff
    height 300px
    overflow-y auto
  .es-travel-list
    border-bottom 1px #EEEEEE solid
    padding 15px 0px
    background #ffffff
    display flex
    justify-content space-between
  .es-input-style
    width 255px
    position relative
  .es-input-style:after
    content ' '
    display block
    width 100%
    height 1px
    background RGB(240, 241, 244)
    position absolute
    left 0
    top 40px
  .es-input-style-bottom:after
    display none
  .es-mark
    color $train-color-theme-blue
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1505591b"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./password-retrieval.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./password-retrieval.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m1505591b"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"component":true},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-button':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'es-dialog':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/dialog/index.mpx?isComponent&outputPath=components%2Findex3651661c%2Findex")),'es-icon':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'drawer-bottom':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
